import Vue from 'vue'
import EventBus from 'vue-bus-ts'
Vue.use(EventBus)
export default new EventBus.Bus()
